import { inputCls } from "../input-class";

export function NumberControl({
  id,
  value,
  disabled,
  onChange,
}: {
  id: string;
  value: string | null;
  disabled?: boolean;
  onChange: (next: string | null) => void;
}) {
  return (
    <input
      id={id}
      type="number"
      value={value ?? ""}
      disabled={disabled}
      inputMode="decimal"
      onChange={(e) => onChange(e.target.value || null)}
      className={inputCls}
    />
  );
}
